import React from "react";
import ButtonCell from "../buttons/ButtonCell";
import { RuleItem } from "../../interfaces/RuleItem";
import { ActionOnKey } from "../../interfaces/ActionOnKey";
import { CharacterHistoryContext } from "../../contexts/CharacterHistoryContext";
import { RuleModuleContext } from "../../contexts/RuleModuleContext";
import { XPSystemContext } from "../../contexts/XPSystemContext";

export default () => {
  const { updateRank, getCurrent } = React.useContext(CharacterHistoryContext);
  const ruleModule = React.useContext(RuleModuleContext);
  const { getXPConfigs } = React.useContext(XPSystemContext);
  const [classChosen, setClassChosen] = React.useState("");
  const [started, setStarted] = React.useState(false);

  const availableClasses = ruleModule.availableRuleItems(getCurrent().rankData);

  const selectClass = (event: any) => {
    setClassChosen(event.target.value);
  };

  const startAdd = () => {
    setClassChosen(availableClasses[0].key);
    setStarted(true);
  };

  const addClassAndReset = () => {
    const action: ActionOnKey = { key: classChosen, action: "inc" };
    if (ruleModule.levelUpOptions) {
      updateRank({
        updateRankAction: action,
        ruleItemConfig: ruleModule.config,
        levelUpOptionsAndConfig: {
          levelUpOptions: ruleModule.levelUpOptions,
          xpConfigs: getXPConfigs(),
        },
      });
    } else {
      updateRank({
        updateRankAction: action,
        ruleItemConfig: ruleModule.config,
      });
    }
    setStarted(false);
  };

  if (availableClasses.length < 1) {
    return null;
  }

  const availableClassOptions = availableClasses.map(
    (item: RuleItem, i: number) => {
      return (
        <option value={item.key} key={i + "_" + item.key}>
          {item.name}
        </option>
      );
    }
  );

  if (started) {
    return (
      <>
        <select
          data-test={`select-item-${ruleModule.key}`}
          className="textCell inline-select inline-select-background"
          value={classChosen}
          onChange={(event) => selectClass(event)}
        >
          {availableClassOptions}
        </select>
        <ButtonCell
          buttonText="Add"
          dataTest={`add-item-${ruleModule.key}`}
          classes="cancel-edit"
          onClick={addClassAndReset}
        />
      </>
    );
  }

  const desc =
    availableClasses.length < ruleModule.list.length
      ? `Multi ${ruleModule.ruleItemName}`
      : `Select ${ruleModule.ruleItemName}`;
  return (
    <ButtonCell
      buttonText={desc}
      dataTest={`add-item-${ruleModule.key}`}
      classes="grid-cell-fill"
      onClick={startAdd}
    />
  );
};
